import React from 'react';
import Hero from './Hero';
import Brief from './Brief';

// Images
import seekjobs from '../../img/SEEK/SEEK_feature@2x.png';
import performanceLeader from '../../img/performanceLeader/performanceLeader_feature@2x.png';
import medibank from '../../img/medibank/MB_Cover@2x.jpg';
import sportsmate from '../../img/sportsmate/Sportsmate_about@2x.png';
import ittybittyapps from '../../img/ittybittyapps/Reveal@2x.png';
import outwaremobile from '../../img/outware/snapsendsolve@2x.png';
import monoshift from '../../img/monoshift/monoshift@2x.png';
import generativeArt from '../../img/personalProject/nightCity-poster-001@2x.png';

const readmoreCTA = "Read More"

const sectionContent = [
  {
    themeColor: '#e9ecf1',
    year: "Jun 2019 – Present",
    company: "SEEK",
    role: "UX designer",
    leadParagraph: "SEEK is the leading employment marketplace in Australia. I work as a liaison between the business direction and the user needs. Conducting user research, creating surveys, analysing usage pattern is what I do everyday.",
    nextPage: readmoreCTA,
    featuredImage: {
      backgroundImage: `url(${seekjobs})`,
    },
    pageUrl: "/seek",
    workingProgress: true
  },
  {
    themeColor: '#29cd9e',
    year: "AUG 2018 – Present",
    company: "Performance Leader",
    role: "Product designer",
    leadParagraph: "Performance Leader's mission is to create a flexible and agile feedback culture for professional firms. Working as a freelance product designer, I established  the web and mobile app design language.",
    nextPage: readmoreCTA,
    featuredImage: {
      backgroundImage: `url(${performanceLeader})`,
    },
    pageUrl: "/performanceLeader",
  },
  {
    themeColor: '#E9696D',
    year: "Jun 2018 – Mar 2019",
    company: "Medibank",
    role: "Senior Product designer",
    leadParagraph: "Medibank is a private health insurance provider. I contracted as a senior product designer to conceptualise the mobile app. I delivered features to help customers to get the most out of their cover and ease the claiming process.",
    nextPage: "Read more",
    featuredImage: {
      backgroundImage: `url(${medibank})`,
    },
    pageUrl: "/medibank",
  },
  {
    themeColor: 'linear-gradient(90deg, #33D19E 12.5%, #0465CC 87.5%)',
    year: "Mar 2017 – Jun 2018",
    company: "Sportsmate",
    role: "Lead Product designer",
    leadParagraph: "The featured app you will see on AppStore during the sports season! As a lead designer, I've worked on rich features to help fans to follow the games anytime. Podcasts, favourite, widgets and final bracket are the key features I've introduced to the app.",
    nextPage: readmoreCTA,
    featuredImage: {
      backgroundImage: `url(${sportsmate})`,
    },
    pageUrl: "/sportsmate",
  },
  {
    themeColor: '#282D3E',
    year: "Feb 2015 – Feb 2017",
    company: "Itty Bitty Apps",
    role: "Senior UX/UI designer",
    leadParagraph: "Itty Bitty Apps is an independent software company, known for its iOS inspector app Reveal. I served as a UX/UI designer for the consulting projects, and also contributed to the design of Reveal.",
    nextPage: readmoreCTA,
    featuredImage: {
      backgroundImage: `url(${ittybittyapps})`,
    },
    pageUrl: "/ittybittyapps",

  },
  {
    themeColor: '#F2F4F8',
    year: "Aug 2012 – Feb 2015",
    role: "Visual designer",
    company: "Outware Mobile",
    leadParagraph: "Outware Mobile is one of the pioneers of mobile app development in Australia. I started my career as a junior visual designer, was responsible for creating UI design for various client including ANZ, Transport NSW, and Telstra.",
    nextPage: readmoreCTA,
    featuredImage: {
      backgroundImage: `url(${outwaremobile})`,
    },
    pageUrl: "/outware",
  },
  {
    themeColor: '#000B15',
    year: "Jan 2012 - JUL 2012",
    role: "Design Intern",
    company: "Monoshift",
    leadParagraph: "Monoshift is a creative agency that partners with world-leading brands to build their digital campaign. As an intern, I was responsible for supporting LG 3D TV campaign from creating concepts to analysing user flows.",
    nextPage: readmoreCTA,
    featuredImage: {
      backgroundImage: `url(${monoshift})`,
    },
    pageUrl: "/monoshift",
  },
  {
    themeColor: '#ff5151',
    year: "May 2016 - Present",
    role: "Personal project",
    company: "Generative Art",
    leadParagraph: "I enjoy being an artist for my own outside of my work. It works like meditation to me when focusing on something without pursuing the business objectives.",
    nextPage:readmoreCTA,
    featuredImage: {
      backgroundImage: `url(${generativeArt})`,
    },
    pageUrl: "/personal",
  }
];

const Introduction = () => (
  <section>
    {sectionContent.map(item => (
      <div key={item.company} className="extra-margin-top card-offset">
        <Hero
          style={item.featuredImage}
          tagline={item.tagline} />
        <Brief
          year={item.year}
          role={item.role}
          company={item.company}
          leadParagraph={item.leadParagraph}
          nextPage={item.nextPage}
          themeColor={item.themeColor}
          pageUrl={item.pageUrl}
          workingProgress={item.workingProgress}
        />
      </div>
    ))}
  </section>
);

export default Introduction;



// WEBPACK FOOTER //
// ./src/layout/hero/Introduction.js